import { Route, Routes } from "react-router-dom";
import ReadalSystems from "../Components/Main/main";
import ReadalPortFolio from "../Components/Portfolio/main";
import ReadalContactForm from "../Components/Contact/main";
import ReadalConstruction from "../Components/Construction/main";

export function RoutesManager () {
    return (
        <Routes>
            <Route path="/" element={< ReadalSystems/>} />
            <Route path="/contact" element={< ReadalContactForm/>} />
            <Route path="/portfolio" element={< ReadalPortFolio/>} />
            <Route path="/construction" element={<ReadalConstruction />} />
        </Routes>
    )
}